import axios from '@/extensions/axios'

const actions = {
  create ({ commit, state }) {
    return axios.post('brands', {
      name: state.newBrand.name
    }).then(({ data }) => {
      commit('ADD', data)
      commit('CLEAR_NEW')
    })
  },

  remove ({ commit }, key) {
    return axios.delete('brands/' + key).then(() => {
      commit('REMOVE', key)
    })
  },

  get ({ commit }) {
    return axios.get('brands').then(({ data }) => {
      commit('SET', data)
    })
  },

  update ({ commit }, brand) {
    return axios.put('brands/' + brand.uuid, brand).then(({ data }) => {
      commit('UPDATE', data)
      commit('SET_ACTIVE', data.uuid)
    })
  }
}

export default actions
